import * as Sentry from "@sentry/react";
import { config } from "./config.js";

Sentry.init({
  dsn: "https://755ea9b2735e6b25b779185361d46f7a@o4511122685952000.ingest.us.sentry.io/4511122690080768",
  environment: config.sentryEnvironment || "unknown",

  integrations: [
    // Performance: capture page loads, navigations, and web vitals
    Sentry.browserTracingIntegration(),
    // Session replay on errors
    Sentry.replayIntegration(),
    // Capture fetch/XHR failures as errors
    Sentry.httpClientIntegration(),
    // Forward console.warn and console.error to Sentry logs
    Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
  ],

  // Logging
  enableLogs: true,

  // Tracing: capture 100% of transactions (low-traffic campaign site)
  tracesSampleRate: 1.0,

  // Session Replay: only record sessions where an error occurs
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,

  // Filter out noisy logs
  beforeSendLog: function (log) {
    // Don't send debug-level logs to Sentry
    if (log.level === "debug") return null;
    return log;
  },
});
